module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("83mLv"))).then(() => parcelRequire('ikE14'));